
import { forwardRef, useEffect, useMemo, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import { commonFormFields } from "../../FeuConstants";
import { useParams } from "react-router";
import "./FeuC16OnShorePowerSupply.scss";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";
const FeuC16OnShorePowerSupply = forwardRef(({ C16OnShorePowerSupply, refetchMonitoringData,vesselMstId }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const savedValuesRef = useRef({});
    const { dirtyFields } = formState;
    const isC16Dirty = !!(dirtyFields?.c16 && Object.keys(dirtyFields.c16).length > 0);

    useEffect(() => {
        if (C16OnShorePowerSupply) {
            reset(prev => ({ ...prev, c16: C16OnShorePowerSupply }));
        }
    }, [C16OnShorePowerSupply, reset]);


    const c16Fields = useMemo(() => {
        return commonFormFields.reduce((acc, field) => {
            if (field.name === "dataSources") return acc;
            if (field.name === "descriptionOfProcedure") {
                acc.push({
                    ...field,
                    label:
                        "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
                });
            } else {
                acc.push(field);
            }
            return acc;
        }, []);
    }, []);

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c16");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC16Dirty || !isChanged) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c16");
        const payload = {
            ...c16Fields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const C16OnShorePowerSupply = await callApi({
                method: "POST",
                url: API_ROUTES.C16(vesselMstId),
                data: payload,
            });
            if (C16OnShorePowerSupply?.isSuccess) {
                emitToasterMsg("success", "Table C.1.6", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c16: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                // emitToasterMsg("success", "Table C16", "Created successfully");
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.1.6", C16OnShorePowerSupply?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.1.6", error.errorMessage);
        }
    };


    return (
        <div className="b7-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Monitoring energy provided by on-shore power supply</h6>
                </MDBCol>
            </MDBRow>
            {c16Fields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-4" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c16.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c16_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c12_save_btn"
                    disabled={!isC16Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>Save</Button>
            </div>
        </div>
    );

})

export default FeuC16OnShorePowerSupply;